export const sleep = (m: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, m);
  });
